import {Component, output} from '@angular/core';

@Component({
  selector: 'lib-swipeable',
  imports: [],
  templateUrl: './swipeable.component.html',
  styleUrl: './swipeable.component.scss'
})
export class SwipeableComponent {

  private touchStartX = 0;
  private touchStartY = 0;
  private threshold = 30;

  swipeLeft = output();
  swipeRight = output();
  swipeUp = output();
  swipeDown = output();

  onTouchStart(event: TouchEvent): void {
    this.touchStartX = event.touches[0].clientX;
    this.touchStartY = event.touches[0].clientY;
  }

  onTouchEnd(event: TouchEvent): void {
    const touchEndX = event.changedTouches[0].clientX;
    const touchEndY = event.changedTouches[0].clientY;
    const deltaX = touchEndX - this.touchStartX;
    const deltaY = touchEndY - this.touchStartY;

    if (Math.abs(deltaX) > Math.abs(deltaY)) {
      if (deltaX > this.threshold) {
        this.swipeRight.emit();
      } else if (deltaX < -this.threshold) {
        this.swipeLeft.emit();
      }
    } else {
      if (deltaY > this.threshold) {
        this.swipeDown.emit();
      } else if (deltaY < -this.threshold) {
        this.swipeUp.emit();
      }
    }
  }
}
